import React from 'react';
import '../Solutions/solutions.css';
import { FaCogs, FaHandshake, FaLightbulb, FaRobot } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const cards = [
  {
    title: 'Tech Stack',
    description: 'Explore the futuristic technologies powering our products.',
    icon: <FaCogs />,
    path: '/solutions/tech-stack'
  },
  {
    title: 'Collaborations',
    description: 'Discover innovation through our strategic partnerships.',
    icon: <FaHandshake />,
    path: '/solutions/collaborations'
  },
  {
    title: 'Innovation Hub',
    description: 'R&D-driven ideas shaping the future of digital ecosystems.',
    icon: <FaLightbulb />,
    path: '/solutions/innovation-hub'
  },
  {
    title: 'AI Integrations',
    description: 'Smart solutions combining automation and intelligence.',
    icon: <FaRobot />,
    path: '/solutions/ai-integrations'
  }
];

const Solutions = () => {
  const navigate = useNavigate();

  return (
    <div className="solutions-container">
      <div className="solutions-header">
        <h1>Innovative Solutions</h1>
        <p>Discover the technologies, ideas, and collaborations that define our future.</p>
      </div>

      <div className="solutions-grid">
        {cards.map((card, index) => (
          <motion.div
            key={index}
            className="solution-card"
            whileHover={{ scale: 1.05 }}
            onClick={() => navigate(card.path)}
          >
            <div className="icon">{card.icon}</div>
            <h2>{card.title}</h2>
            <p>{card.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Solutions;
